<template>
  <a class="brand-lockup" :href="to" target="_blank" rel="noopener noreferrer" aria-label="FindBao">
    <span class="brand-mark" aria-hidden="true"><img src="/images/findbao-logo.png" alt="" /></span>
    <span class="brand-copy">
      <strong>FindBao</strong>
      <small v-if="showTagline">{{ t('app.brandTagline') }}</small>
    </span>
  </a>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
withDefaults(defineProps<{ to?: string; showTagline?: boolean }>(), {
  to: import.meta.env.VITE_APP_HOME_DOMAIN,
  showTagline: true,
})
const { t } = useI18n()
</script>
<style scoped>
.brand-lockup {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}
.brand-mark {
  flex: none;
  width: 40px;
  height: 40px;
  padding: 5px;
  display: grid;
  place-items: center;
  border: 1px solid color-mix(in srgb, var(--fb-sidebar-text) 10%, transparent);
  border-radius: 12px;
  background: var(--fb-sidebar-logo-bg, var(--fb-surface));
  box-shadow: 0 8px 22px rgba(10, 37, 51, 0.1);
}
.brand-mark img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.brand-copy {
  min-width: 0;
  display: grid;
  line-height: 1.1;
}
.brand-copy strong {
  font-size: 20px;
  letter-spacing: -0.04em;
}
.brand-copy small {
  margin-top: 4px;
  overflow: hidden;
  color: var(--fb-ink-soft);
  font-size: 9px;
  font-weight: 650;
  letter-spacing: 0.02em;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
